<template>
  <v-autocomplete
    autocomplete="off"
    menu-props="auto"
    :disabled="selectList.length === 0"
    :items="selectList"
    @change="$emit('input', $event)"
    :value="value"
    label="Selecione o responsável."
    item-text="name"
    item-value="value"
  />
</template>
<script>
import { getNotClientNames } from '@/services/UserService';

export default {
  data: () => ({
    usersList: [],
  }),
  computed: {
    selectList() {
      const formatedUserList = this.usersList.map((user) => ({
        name: user.employee.name,
        value: user.employee.id,
      }));
      return formatedUserList;
    },
  },
  methods: {
    async geUsers() {
      const resp = await getNotClientNames(this.$apollo);
      this.usersList = resp.users;
    },
  },
  created() {
    this.geUsers();
  },
  props: ['value'],
};
</script>
